import ApiService from "./api.service";

export default class DevolutionTicketService {
    private apiService = new ApiService();

    getAllForOrderDropdown = async(orderId: string) => {
        try {
            const response = await this.apiService.getAllForOrderDropdown(orderId);
            if (response.status === 204) return [];
            if (response.status !== 200) throw response;
            return response.data;
        } catch (error) {
            console.error('Erro ao consultar protocolos de devolução relacionados ao pedido');
            throw error;
        }
    }

    resendDevolutionApprovalMail = async(ticketId: string) => {
        try {
            const response = await this.apiService.resendDevolutionApprovalMail(ticketId);
            if (response.status !== 200) throw response;
        } catch (error) {
            console.error('Erro ao tentar reenviar e-mail de aprovação');
            throw error;
        }
    }
}